// BẢN SAO y hệt ante-nodejs-kit/src/utils/stableStringify.js (test đối chiếu ở kit: test/StableStringify.test.js).
// Sửa thì sửa cùng lúc mọi bản sao: ante-nodejs-kit, ante-backend, ante-react-kit, ante-web, ante-pos (alpine-kit), ante-mobile-user (react-native-kit).
import libStringify from 'fast-json-stable-stringify';

// Bản thay fast-json-stable-stringify@2.1.0 (gọi không tham số opts) — ra chuỗi GIỐNG HỆT TỪNG KÝ TỰ
// vì checksum dòng (hashToNum(stringify(row))) được lưu trong DB. Test: test/StableStringify.test.js.
// Nhanh hơn nhờ:
//  - Nhớ danh sách khoá đã sắp + tiền tố '"khoá":' theo "hình dạng" đối tượng (danh sách khoá theo thứ tự gốc):
//    dòng cùng bảng có cùng hình dạng nên khỏi sort và khỏi JSON.stringify(khoá) mỗi lần.
//  - Không tra .toJSON trên chuỗi/số/boolean (thư viện tra cả trên giá trị nguyên thuỷ — vô ích khi prototype
//    không có toJSON; nếu môi trường gắn toJSON vào prototype nguyên thuỷ thì dùng thẳng thư viện).
// Thứ tự xử lý mỗi nút y như thư viện: gọi toJSON() (không tham số) MỘT lần, rồi undefined → bỏ qua,
// số không hữu hạn → null, không phải object → JSON.stringify, mảng (phần tử rỗng → null), null, đối tượng
// (vòng lặp → TypeError, giá trị rỗng → bỏ khoá).

// Bộ nhớ giới hạn theo TỔNG số khoá đã lưu (không theo số hình dạng): dòng 300 cột tốn gấp trăm lần đối tượng
// 3 khoá. Vượt ngân sách thì bỏ hết làm lại — đối tượng có tên khoá thay đổi liên tục (vd khoá = mã hàng)
// không làm phình bộ nhớ, kể cả trên máy yếu.
const KEY_BUDGET = 50000;
const SMALL = 6;
const RECENT = 4;
let shapes = new Map();
let recentByLen = new Map();
let cachedKeys = 0;
const heads = new Map();

// Tiền tố '"khoá":' cho đối tượng ít khoá (vd { field, value }). Đầy 2000 tên thì thôi thêm (không xoá làm lại):
// tên khoá thay đổi liên tục chỉ tốn một lần tra trượt, tên hay dùng đã nằm sẵn từ đầu.
function headOf(k) {
    let h = heads.get(k);
    if (h === undefined) {
        h = JSON.stringify(k) + ':';
        if (heads.size < 2000) heads.set(k, h);
    }
    return h;
}

function sameKeys(a, b) {
    if (a.length !== b.length) return false;
    for (let i = 0; i < a.length; i++) if (a[i] !== b[i]) return false;
    return true;
}

// Tra nhanh theo số khoá: so thẳng danh sách khoá với vài hình dạng gần nhất cùng độ dài (tên khoá thường
// là cùng chuỗi nội bộ nên === rất rẻ) — khỏi nối cả trăm tên cột thành chữ ký mỗi lần.
function shapeOf(keys) {
    let list = recentByLen.get(keys.length);
    if (list !== undefined) {
        for (let i = 0; i < list.length; i++) if (sameKeys(list[i].orig, keys)) return list[i];
    }
    const sig = keys.join('\u0000');
    let s = shapes.get(sig);
    // So lại danh sách khoá gốc: khoá có chứa '\u0000' có thể trùng chữ ký với hình dạng khác.
    if (s === undefined || !sameKeys(s.orig, keys)) {
        const sorted = keys.slice().sort();
        s = { orig: keys, keys: sorted, heads: sorted.map((k) => JSON.stringify(k) + ':') };
        cachedKeys += keys.length;
        if (cachedKeys > KEY_BUDGET) {
            shapes = new Map();
            recentByLen = new Map();
            cachedKeys = keys.length;
            list = undefined;
        }
        shapes.set(sig, s);
    }
    if (list === undefined) {
        list = [];
        recentByLen.set(keys.length, list);
    }
    if (list.length >= RECENT) list.pop();
    list.unshift(s);
    return s;
}

// Thân thư viện SAU bước toJSON.
function body(node, seen) {
    if (node === undefined) return;
    if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
    if (typeof node !== 'object') return JSON.stringify(node);
    if (Array.isArray(node)) {
        let out = '[';
        for (let i = 0; i < node.length; i++) {
            if (i) out += ',';
            out += str(node[i], seen) || 'null';
        }
        return out + ']';
    }
    if (node === null) return 'null';
    if (seen.indexOf(node) !== -1) throw new TypeError('Converting circular structure to JSON');
    seen.push(node);
    const keys = Object.keys(node);
    let out = '';
    if (keys.length <= SMALL) {
        // Đối tượng ít khoá (vd { field, value }): sắp tại chỗ rẻ hơn dựng chữ ký hình dạng.
        if (keys.length > 1) keys.sort();
        for (let i = 0; i < keys.length; i++) {
            const value = str(node[keys[i]], seen);
            if (!value) continue;
            if (out) out += ',';
            out += headOf(keys[i]) + value;
        }
    } else {
        const sh = shapeOf(keys);
        const sorted = sh.keys;
        const heads = sh.heads;
        for (let i = 0; i < sorted.length; i++) {
            const value = str(node[sorted[i]], seen);
            if (!value) continue;
            if (out) out += ',';
            out += heads[i] + value;
        }
    }
    seen.pop();
    return '{' + out + '}';
}

function str(node, seen) {
    const t = typeof node;
    // Nguyên thuỷ phổ biến: prototype không có toJSON (đã kiểm lúc nạp) → đi thẳng như thư viện.
    if (t === 'string') return JSON.stringify(node);
    if (t === 'number') return isFinite(node) ? '' + node : 'null';
    if (t === 'boolean') return node ? 'true' : 'false';
    if (node && node.toJSON && typeof node.toJSON === 'function') node = node.toJSON();
    return body(node, seen);
}

const primitivesPlain =
    !Object.prototype.hasOwnProperty.call(String.prototype, 'toJSON') &&
    !Object.prototype.hasOwnProperty.call(Number.prototype, 'toJSON') &&
    !Object.prototype.hasOwnProperty.call(Boolean.prototype, 'toJSON') &&
    !('toJSON' in Object.prototype);

export default function stableStringify(data) {
    if (!primitivesPlain) return libStringify(data);
    return str(data, []);
}
